'use strict';

import * as domUtils from '../util/dom';
var Debug = require('../util/debug')('embed');

var NAMESPACE = 'embed';

module.exports = {
	create: function (api) {

		api.on(NAMESPACE + '.metadata', function (metadata) {

			domUtils.addEvents(api.element(), 'keyup', function (event) {
				var keyName = domUtils.getKeyFromKeyEvent(event);
				if (keyName === 'keye') {
					Debug('e pressed');

					var embedElement = domUtils.fromString(
							'<textarea style="z-index:-1; position:absolute; top=0;">' +
								'<div style="position:relative; padding-bottom:56.25%;">' +
									'<iframe style="position:absolute; top:0; left:0; width: 100%; height: 100%;" ' +
										'frameborder="0" allowfullscreen="true" scrolling="no" ' +
										'src="https://api.svt.se/videoplayer-embed/' + metadata.detail.programVersionId + '">' +
									'</iframe>' +
								'</div>' +
							'</textarea>'
					);
					api.element().appendChild(embedElement);
					embedElement.select();
					try {
						var successful = document.execCommand('copy');
						var msg = successful ? 'successful' : 'unsuccessful';
						Debug('Copying text command was ' + msg);
					} catch (err) {
						Debug('Oops, unable to copy');
					}
					api.element().removeChild(embedElement);

				}
			}, NAMESPACE);

		});

	},
	destroy: function (api) {
		api.off(NAMESPACE + '.metadata');
	}
};




// WEBPACK FOOTER //
// ./src/js/plugins/embed.js